module.exports = __webpack_public_path__ + "static/tailwind-10db687509de38a6f07851a70ac0591a.png";